import { ReactNode, useState } from 'react';
import { ApiError } from '../api';

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  const e = error as ApiError;
  return (
    <div className="error" role="alert">
      {e.message ?? String(error)}
      {Array.isArray(e.details) && <ul>{e.details.map((d: any, i: number) => <li key={i}>{d.path}: {d.message}</li>)}</ul>}
    </div>
  );
}

export function Field({ label, children, hint }: { label: string; children: ReactNode; hint?: string }) {
  return <label className="field"><span>{label}</span>{children}{hint && <small className="muted">{hint}</small>}</label>;
}

/** Mező forrásának jelölése (ember / ügynök / integráció / import). */
export function SourceBadge({ src }: { src?: { source: string; at: string } }) {
  if (!src || src.source === 'user') return null;
  const kind = src.source.split(':')[0];
  const label = kind === 'agent' ? 'ügynök' : kind === 'integration' ? 'integráció' : kind === 'import' ? 'import' : kind;
  return <span className={`badge badge-${kind}`} title={`${src.source} · ${new Date(src.at).toLocaleString('hu-HU')}`}>{label}</span>;
}

export function useAsync() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const run = async <T,>(fn: () => Promise<T>): Promise<T | undefined> => {
    setBusy(true); setError(null);
    try { return await fn(); } catch (e) { setError(e); return undefined; } finally { setBusy(false); }
  };
  return { busy, error, run, setError };
}

export const fmtDate = (s: string) => new Date(s).toLocaleString('hu-HU', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
